export default {
  httpBaseUri: "https://localhost:5022",
  httpServiceBaseUri: "https://localhost:5022/graphql",
  wsServiceBaseUri: "wss://localhost:5022/graphql",

  showConfigInTitle: true,
  configTitle: "[CI]",

  theme: {
    logoContainer: "images-dev"
  },

  errors: {
    showDetail: false
  }
}
